import Vue from 'vue'
import Vuex from 'vuex'

import login from './modules/login.module'
import errors from './modules/errors.module'
import groups from './modules/grupos.module'
import prematriculas from './modules/prematriculas.module'
import localizaciones from './modules/localizaciones.module'
import matricula from './modules/matricula.module'

Vue.use(Vuex)


/**
 * Set the store modules
 * 
 */

const store =  new Vuex.Store({

    modules: {

        Login: login,
        Errors: errors,
        Groups: groups,
        Prematriculas: prematriculas,
        Localizaciones: localizaciones,
        Matricula: matricula

    }

})

export default store